const CLIENT_SCHEMA = {
  rol: 'client',
  sex: '',
  expenses: { 
    total: 0, 
    max: 0, 
    min: 0
  },
  image: 'https://firebasestorage.googleapis.com/v0/b/intelligence-web.appspot.com/o/assets%2Favatar-1577909_640.png?alt=media&token=eca8ce66-2a8c-4ee1-8f71-b8d2b8f4f3bf',
};

const MAYOR_SCHEMA = {
  rol: 'major',
  type: 'company',
  growth: 0,
  revenue: 0,
  products: '',
  image: 'https://firebasestorage.googleapis.com/v0/b/intelligence-web.appspot.com/o/assets%2Fphoto_2019-03-24_01-27-50.jpg?alt=media&token=a30dd3a6-f96a-4a81-a14a-2d5bbe331754'
};

const UNIVERSAL_FIELDS = {
  dateOfRegister:'',
  consultedProducts: 0,
  profileComplete: false,
  enabled: true,
};

export {
  CLIENT_SCHEMA,
  MAYOR_SCHEMA,
  UNIVERSAL_FIELDS
};